export default "__VITE_ASSET__DG9rzqGA__"